export default "__VITE_ASSET__7zIyS6QQ__"